import { defineMessages } from "react-intl";

const PASSWORD = "password";

const PasswordMessages = defineMessages({
  blacklistedWord: {
    id: `${PASSWORD}.blacklisted-word`,
    description: "Prompt for new password criterion",
    defaultMessage: "Do not include common phrases"
  },
  oneNumber: {
    id: `${PASSWORD}.one-number`,
    description: "Prompt for new password criterion",
    defaultMessage: "One number"
  },
  sixCharacterMinimum: {
    id: `${PASSWORD}.six-character-minimum`,
    description: "Prompt for new password criterion",
    defaultMessage: "Six character minimum"
  },
  oneSpecialCharacter: {
    id: `${PASSWORD}.one-special-character`,
    description: "Prompt for new password criterion",
    defaultMessage: "One special character"
  },
  omitEmail: {
    id: `${PASSWORD}.omit-email`,
    description: "Prompt for new password criterion",
    defaultMessage: "Do not include email address"
  },
  omitUsername: {
    id: `${PASSWORD}.omit-username`,
    description: "Prompt for new password criterion",
    defaultMessage: "Do not include username"
  },
  invalidNewPassword: {
    id: `${PASSWORD}.invalid-new-password`,
    description:
      "Error message for when new password has not met validation criteria",
    defaultMessage: "Please enter a valid password."
  },
  unmetCriteria: {
    id: `${PASSWORD}.unmet-criteria`,
    description:
      "Screen reader text to provide additional context for error state",
    defaultMessage: "You have not met the following password criteria:"
  },
  initialCriteria: {
    id: `${PASSWORD}.initial-criteria`,
    description:
      "Screen reader text to provide additional context for password requirements",
    defaultMessage: "Please enter a password meeting the following criteria:"
  }
});

export default PasswordMessages;
